module.exports = window.moment